import { type FeatureFlag } from '@nextgen-web-framework/core';
import { ReadonlyURLSearchParams } from 'next/navigation';

/* eslint-disable  @typescript-eslint/no-explicit-any */
export type CMSTransformerDataType = any;
export enum CustomerType {
  ABO = 'BUSINESS_OWNER',
  MEMBER = 'MEMBER',
}

export const NAV_HEADER_ID = 'mega-menu-header-container';

export const SessionStorageKeys = {
  BANNER_DISPLAYED_TIME: 'bannerDisplayedTime',
};
export const LocalStorageKeys = {
  CHECKOUT_ID: 'checkoutId',
  CHECKOUT_VERSION: 'checkoutVersion',
  CART_ID: 'cartId',
  WAREHOUSE_ID: 'warehouseId',
  USER_NAME: 'userName',
  PARTY_ID: 'partyId',
  USER_TYPE: 'userType',
  SHARECODE_ATTRIBUTES: 'sharecodeAttributes',
  LAST_NAME: 'lastName',
  EMAIL: 'email',
  BANNER_DISPLAYED_TIME: 'bannerDisplayedTime',
};

export const CookieStorageKeys = {
  NEXT_LOCALE: 'NEXT_LOCALE',
};

export enum ShopBy {
  OFFERS = 'offers',
  SOP = 'sop',
}

export enum PageCategory {
  EXPRESS = 'EXPRESS_PAGE',
  STANDARD = 'STANDARD_PAGE',
  DEFERRED = 'DEFERRED_PAGE',
}

export const STATUS_CODE = {
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  INTERNAL_SERVER_ERROR: 500,
};

export enum OrderPageType {
  ORDER_DETAIL_PAGE = 'order-details',
  GROUP_ORDER_DETAIL_PAGE = 'group-order',
  PAYMENT_PAGE = 'checkout-retry',
  ORDER_TRACKING_PAGE = 'order-tracking',
  RETURN_DETAIL_PAGE = 'return-details',
  DELIVERY_TRACKING = 'delivery-tracking',
}

export enum CMSBannerType {
  BANNER_WITH_CTA = 'BannerWithCta',
  VIDEO_BANNER_WITH_CTA = 'VideoBannerWithCta',
  BANNER_WITHOUT_CTA = 'BannerWithoutCta',
}

export enum BannerComponentType {
  HERO_BANNER = 'hero_banner',
  VIDEO_BANNER = 'video_banner',
  STANDARD_BANNER_WITH_NO_CTA = 'standard_banner_no_cta',
}

type ContentDetailType = {
  [key in ContentType]: {
    uid: string;
  };
};

export const contentDetailType: ContentDetailType = {
  resources: {
    uid: 'resource_detail_template',
  },
  promotions: {
    uid: 'promotion_detail_template',
  },
  articles: {
    uid: 'article_detail_template',
  },
};
export type ContentType = keyof typeof Content;

export enum Content {
  resources = 'resources',
  promotions = 'promotions',
  articles = 'articles',
}

export enum TENANT {
  THA = 'tha',
  GLOBAL = 'global',
  LATAM = 'latam',
}

export interface LocalesData {
  defaultLocale: string;
  mappedLocales: {
    [key: string]: string;
  };
}

export interface NextIntlLocalizedPageProps {
  params: {
    locale: string;
    country: string;
    [key: string]: string | string[];
  };
  searchParams?: ReadonlyURLSearchParams | null;
}

export interface BasePageProps {
  featureFlags?: FeatureFlag;
  messages?: Record<string, string>;
  locale?: string;
  notFoundPage?: boolean;
  notFoundData?: Omit<BasePageProps, 'notFoundData'>;
  showError?: boolean;
  data: {
    [key: string]: CMSTransformerDataType;
  };
  seoData?: {
    [key: string]: CMSTransformerDataType;
  };
}
export interface WithNextgenISROpts {
  masterDataProfiles?: string[];
}

type ConfigType = Record<string, string | object>;

export interface ConfigDataInterface {
  configs: ConfigType;
  secrets: ConfigType | {};
}
export interface WebshopConfig {
  toastDisplayTime?: number;
}
